module.exports = __webpack_public_path__ + "img/project12_3.jpg.cd170297.webp";